import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Router } from '@angular/router';
import { IUserModel } from 'src/app/core/models/masters/user-master.model';
import { GenericListView } from 'src/app/infrastructure/infrastructure-services/generics/genericlistview/generic-list-view';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import * as _moment from 'moment';
import { FormControl } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';

const moment = _moment;


let fromData = '';
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})

export class FilterComponent extends GenericListView<IUserModel>{
  @Output() sortFilter = new EventEmitter<boolean>();
  @Output() FilterColumn = new EventEmitter<any>();
  @Input() shortColumn: any;
  @Input() isActive: boolean | undefined;
  @Input() colType: any;
  @Input() labelType: any;

  public fromDate: any;
  public toDate: any

  constructor(agenericRepository: GenericService<IUserModel>, router: Router) {
    super(agenericRepository, router);
    // alert('apiendPoint---- ' + this.apiEndpoint)
    //  this.setListViewDataSourceURL = "Project/GetProjectListService";
    //  this.setListViewDataSourceURL = "Project/" + this.apiEndpoint;
  }
  
  clearDate() {
    this.fromDate = new Date().getMonth();
    this.toDate = new Date().getMonth();
  }

}
